@if (queryParams$ | async) {}
@if (startAtDateChanged$ | async) {}
@if (endAtDateChanged$ | async) {}

<nz-page-header nzTitle="Файлообменник">
  <nz-page-header-extra>
    <button nz-button nzType="primary" (click)="showFilterModal()">
      <nz-badge nzDot [nzShowDot]="isShowBadge">
        <i nz-icon nzType="filter" style="color: #fff"></i>
      </nz-badge>
    </button>
    <nz-divider nzType="vertical"></nz-divider>
    <button
      nz-button
      nzType="primary"
      nzShape="round"
      (click)="goToCreateFileSharing()"
    >
      Создать
    </button>
    <nz-divider nzType="vertical"></nz-divider>
    <button nz-button nzType="primary" nzShape="round" (click)="reloadPage()">
      Обновить
    </button>
  </nz-page-header-extra>
</nz-page-header>

<nz-table
  #basicTable
  nzBordered
  nzShowSizeChanger
  [nzData]="files"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzTotal]="fileSharingTotal.getValue()"
  [nzPageIndex]="pageNumber"
  (nzQueryParams)="onQueryParamsChange($event)"
>
  <thead>
    <tr>
      <th>ID</th>
      <th>Тема</th>
      <th>Дата создания</th>
      <th class="user">Сотрудник</th>
    </tr>
  </thead>
  <tbody>
    @for (data of basicTable.data; track $index) {
      <tr class="version-wrapper">
        <td nzTooltipTitle="Подробнее">
          <a
            queryParamsHandling="preserve"
            [routerLink]="[data.id, 'details']"
            [queryParams]="{ pageNumber, pageSize }"
          >
            {{ data.id }}
          </a>
        </td>
        <td>
          <nz-typography
            nz-tooltip
            nzTooltipPlacement="top"
            class="ellipsis-2-lines sharing-theme"
            [nzTooltipTitle]="data.title"
          >
            {{ data.title }}
          </nz-typography>
        </td>
        <td>
          {{ data.createdAt | date: "dd.MM.yy HH:mm" }}
        </td>
        <td>
          {{ data.user }}
        </td>
      </tr>
    }
  </tbody>
</nz-table>

<nz-modal
  nzTitle="Добавить фильтры"
  [nzWidth]="720"
  [(nzVisible)]="isFilterModalVisible"
  (nzOnCancel)="closeFilterModal()"
>
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="filterForm">
      <nz-form-item>
        <nz-form-label [nzSpan]="4" nzFor="id">ID</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="id" id="id" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="4">Дата</nz-form-label>
        <nz-form-control [nzSpan]="20">
          <div class="date-pickers-wrapper">
            <nz-date-picker
              formControlName="startAt"
              nzPlaceHolder="Начальная дата"
              nzFormat="dd.MM.yyyy"
            >
            </nz-date-picker>
            <nz-date-picker
              formControlName="endAt"
              nzPlaceHolder="Конечная дата"
              nzFormat="dd.MM.yyyy"
            >
            </nz-date-picker>
          </div>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
  <div *nzModalFooter>
    <button
      nz-button
      nzType="default"
      nzShape="round"
      (click)="filterModalCancel()"
    >
      Сбросить
    </button>
    <button
      nz-button
      nzType="primary"
      nzShape="round"
      (click)="filterModalOk()"
    >
      Применить
    </button>
  </div>
</nz-modal>
